import pluralize from 'pluralize';
import PT from 'prop-types';
import React from 'react';

import { useIntl } from 'react-intl';
import Text from '~/ui/components/Text/Text';
import * as enums from '~/ui/enums/input';

export default function CharacterLimit({
  limit = enums.CHARACTER_INPUT_LIMIT_LONG,
  value = '',
}) {
  const intl = useIntl();
  const characters = typeof value === 'string' ? value.length : 0;
  const difference = characters - limit;
  const differenceString = pluralize('character', Math.abs(difference), true);

  let message = intl.formatMessage(
    {
      id: 'CharacterLimit.defaultMessage',
      defaultMessage: '{characters}/{limit} characters',
      description:
        'Default character count display. Example: characters = "150", limit = "500"',
    },
    {
      characters,
      limit,
    },
  );
  let color = 'gray-700';

  if (difference > 0) {
    color = 'red-600';
    message = intl.formatMessage(
      {
        id: 'CharacterLimit.exceededMessage',
        defaultMessage:
          'You have exceeded the character limit ({limit}) by {differenceString}',
        description:
          'Message when character limit is exceeded. Example: limit = "500", differenceString = "25 characters"',
      },
      {
        limit,
        differenceString,
      },
    );
  } else if (characters >= limit * 0.9) {
    color = 'peach-500';
    message = intl.formatMessage(
      {
        id: 'CharacterLimit.warningMessage',
        defaultMessage: '{differenceString} left',
        description:
          'Warning message when approaching character limit. Example: differenceString = "25 characters"',
      },
      {
        differenceString,
      },
    );
  }

  return (
    <Text mt={2} color={color} variant="2xs-dense">
      {message}
    </Text>
  );
}

CharacterLimit.propTypes = {
  /** character limit before a warning a thrown */
  limit: PT.number,
  /** string value */
  value: PT.string,
};
